import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // ============================
    // Training Reports - New APIs
    // ============================
    getTrainingOptions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/options')
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    getTrainingOverview(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/overview', { params })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    getTrainingParticipation(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/participation', { params })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    getTrainingTrends(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/trends', { params })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    // ============================
    // Training Exports (Excel)
    // ============================
    exportAttendanceRatePerEvent(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/exports/attendance-rate-per-event', { params, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    exportParticipantsPerCompany(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/exports/participants-per-company', { params, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    exportCoursePopularity(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/exports/course-popularity', { params, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    exportSessionAttendanceHeatmap(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/exports/session-attendance-heatmap', { params, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    exportEventsOverTime(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/exports/events-over-time', { params, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    exportAttendanceTrendOverTime(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/exports/attendance-trend', { params, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    exportCapacityUtilizationTrend(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/exports/capacity-utilization-trend', { params, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    exportTopCoursesRolling(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/training/exports/top-courses-rolling', { params, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    fetchWeeks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/fetchWeeks', { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    dashboardSummary(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/dashboard-summary', data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    taskReport(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/task-report', data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    userReport(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/user-report', data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    downloadPDF(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/download-pdf', data, { responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    downloadPDF2(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/download-pdf2', data, { responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    downloadPDF3(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/download-pdf3', data, { responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    taskDataExport(ctx,data) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .post('reports/taskDataExport',data ,{ responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    userDataExport(ctx,data) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .post('reports/userDataExport',data ,{ responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    taskReportDataExport(ctx,data) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .post('reports/taskReportDataExport',data ,{ responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },


    
    
    

  },
};
